import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Publication = (props) => {
  const { name, publisher, releaseDate, website, authors } = props;
  return (
    <>
      {" "}
      <Container>
        <Row>
          <Col>
            <div style={{ fontWeight: "100", fontSize: "1.25rem" }}>
              {releaseDate}
            </div>
            <div style={{ fontStyle: "italic", fontSize: "1.25rem" }}>
              {publisher}
            </div>
            <a href={website} target="_blank" rel="noopener noreferrer">
              <div style={{ fontWeight: "300", fontSize: "1.5rem" }}>
                {name}
              </div>
            </a>
            <div style={{ fontWeight: "100" }}>{authors}</div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Publication;
